<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-switch
    v-model="seminar.report"
    :loading="loading"
    class="mt-0"
    hide-details
    @click.stop="toggleSubmissionFlag(seminar)"
  />
</template>

<script>
import QUATSError from '../../../plugins/error'

export default {
  props: {
    seminar: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      loading: false
    }
  },
  methods: {
    toggleSubmissionFlag(seminar) {
      this.loading = true
      window.axios.patch('/api/employee-course-report/course/report/seminar/send/flag', {
        seminar_division_id: seminar.id,
        report_send_flg: seminar.report,
      })
        .catch((err) => this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message]))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
